import { render, staticRenderFns } from "./CustomerBilling.vue?vue&type=template&id=0d5b5f32&scoped=true&"
import script from "./CustomerBilling.vue?vue&type=script&lang=js&"
export * from "./CustomerBilling.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBilling.vue?vue&type=style&index=0&id=0d5b5f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b5f32",
  null
  
)

export default component.exports